import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { z } from 'zod'

const vndlyWorkOrderIssuesItemSchema = z.object({
  instanceId: z.number(),
  companyId: z.number(),
  shiftId: z.number(),
  shiftStartsAt: z.string(),
  workerId: z.number(),
  workerName: z.string(),
  vndlyJobTitle: z.string().nullable(),
  issues: z.array(z.string()),
})

export type VndlyWorkOrderIssuesItem = z.infer<
  typeof vndlyWorkOrderIssuesItemSchema
>

const vndlyWorkOrderIssuesItemsSchema = z.array(vndlyWorkOrderIssuesItemSchema)

export type VndlyWorkOrderIssuesItems = z.infer<
  typeof vndlyWorkOrderIssuesItemsSchema
>

type ListVndlyWorkOrderIssuesRequest = {
  page: number
  pageSize: number
  daysAgo?: number | null
  instanceIds?: number[] | null
  companyIds?: number[] | null
}

const listVndlyWorkOrderIssuesResponseSchema = z.object({
  items: vndlyWorkOrderIssuesItemsSchema,
  totalRows: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  pageSize: z.number(),
})

export type ListVndlyWorkOrderIssuesResponse = z.infer<
  typeof listVndlyWorkOrderIssuesResponseSchema
>

export const listVndlyWorkOrderIssues = async (
  request: ListVndlyWorkOrderIssuesRequest
): Promise<ListVndlyWorkOrderIssuesResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    instance_ids: request.instanceIds,
    company_ids: request.companyIds,
  }

  const response = await api.get<ListVndlyWorkOrderIssuesResponse>(
    '/admin/vndly/work_order_associations_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return listVndlyWorkOrderIssuesResponseSchema.parse(response.data)
}
